/** EVM 交易 hash：必须是 0x + 64 位 hex（WC 偶发返回截断 hash，需拒绝） */
export function isValidEvmTxHash(hash) {
  const s = String(hash || '').trim()
  return /^0x[0-9a-fA-F]{64}$/.test(s)
}

/** WC / 钱包 eth_sendTransaction 返回值格式不统一；无效长度返回空字符串 */
export function normalizeTransactionHash(raw) {
  if (raw == null || raw === '') return ''
  if (typeof raw === 'string') {
    const s = raw.trim()
    if (!s || s === '[object Object]') return ''
    if (/^[0-9a-fA-F]{64}$/.test(s)) return `0x${s.toLowerCase()}`
    if (s.startsWith('0x')) {
      const body = s.slice(2)
      if (/^[0-9a-fA-F]{64}$/.test(body)) return `0x${body.toLowerCase()}`
      console.warn('[hieswap] invalid tx hash length', { len: s.length, preview: s.slice(0, 18) })
      return ''
    }
    return ''
  }
  if (typeof raw === 'object') {
    return normalizeTransactionHash(
      raw.transactionHash ?? raw.hash ?? raw.txHash ?? raw.tx_hash ?? raw.result,
    )
  }
  return ''
}
